<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-drink`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.297 3c1.52 0 2.91.856 3.59 2.211l.941 1.878a4.008 4.008 0 013.048 2.94l1.003 4a4 4 0 01-3.633 4.963l-3.715 24.31A2 2 0 0134.554 45H14.445a2 2 0 01-1.977-1.698l-3.717-24.31A4.006 4.006 0 015.12 14.03l1.003-4a4.008 4.008 0 013.048-2.94l.942-1.879A4.014 4.014 0 0113.702 3h21.595zm.933 16H12.77l3.44 22H32.79l3.44-22zm-.933-12H13.702l-2.007 4h-1.68l-1.002 4h30.974l-1.004-4h-1.68l-2.006-4z"/></svg>
</template>
<script>

export default {
  name: 'IconDrink',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
